import { createI18n } from "vue-i18n";
import myar from "../locales/ar.json";
import myen from "../locales/en.json";
import myid from "../locales/id.json";
import myzh from "../locales/zh.json";
import myru from "../locales/ru.json";
import myms from "../locales/ms.json";
import mytr from "../locales/tr.json";
import myhi from "../locales/hi.json";

import {
  en as vuetifyen,
  ar as vuetifyar,
  zhHans as vuetifyzh,
  id as vuetifyid,
  ru as vuetifyru,
  tr as vuetifytr,
} from "vuetify/locale";
export default createI18n({
  legacy: false, // Vuetify does not support the legacy mode of vue-i18n
  locale: "en",
  fallbackLocale: "en",
  messages: {
    en: {
      $vuetify: {
        ...vuetifyen,
      },
      ...myen,
    },
    ar: {
      $vuetify: {
        ...vuetifyar,
      },
      ...myar,
    },
    id: {
      $vuetify: {
        ...vuetifyid,
      },
      ...myid,
    },
    ru: {
      $vuetify: {
        ...vuetifyru,
      },
      ...myru,
    },
    tr: {
      $vuetify: {
        ...vuetifytr,
      },
      ...mytr,
    },
    zh: {
      $vuetify: {
        ...vuetifyzh,
      },
      ...myzh,
    },
    hi: {
      ...myhi,
    },

    ms: {
      ...myms,
    },
  },
});
